const _excluded = ["children", "size", "variant", "disabled", "fullWidth", "startIcon", "endIcon", "rel"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { cx } from "../../helpers/utils/cx";
const sizes = {
  sm: "px-4 py-0 h-9 gap-1 bolt-font-body-s-accent",
  md: "px-6 py-0 h-12 gap-2 bolt-font-body-m-accent",
  lg: "px-6 py-0 h-14 gap-2 bolt-font-body-l-accent"
};
const variants = {
  primary: "bg-action-primary hover:bg-active-action-primary active:bg-active-action-primary text-static-key-light",
  secondary: "bg-neutral-secondary hover:bg-active-neutral-secondary active:bg-active-neutral-secondary text-primary",
  danger: "bg-danger-primary hover:bg-active-danger-primary active:bg-active-danger-primary text-static-key-light",
  tertiary: "bg-special-nulled hover:bg-action-secondary active:bg-action-secondary text-action-primary",
  floating: "bg-layer-floor-2 shadow-md hover:shadow active:shadow disabled:shadow-md text-primary"
};

/**
 * Always set the size prop to the same value as the LinkButton size.
 * @returns IconElement with given size prop.
 */
function withSize(icon, size) {
  return /*#__PURE__*/React.cloneElement(icon, {
    size
  });
}
function LinkButton(_ref, ref) {
  let {
      children,
      size = "md",
      variant = "primary",
      disabled = false,
      fullWidth = false,
      startIcon,
      endIcon,
      rel = "noopener"
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const buttonContent = /*#__PURE__*/React.createElement(React.Fragment, null, startIcon && withSize(startIcon, size), children, endIcon && withSize(endIcon, size));
  return /*#__PURE__*/React.createElement("a", _extends({
    className: cx( /* reset */"no-underline", "inline-flex justify-center items-center flex-none relative rounded-full ease-linear duration-150", fullWidth ? "w-full" : "w-fit", sizes[size], variants[variant], disabled ? "bg-neutral-secondary hover:bg-neutral-secondary active:bg-neutral-secondary text-tertiary cursor-not-allowed pointer-events-none" : "active:scale-975 active:ease-in-out active:duration-100"),
    style: variant === "primary" ? {
      backgroundImage: "var(--color-bg-action-primary)"
    } : {} // allows gradient backgrounds
    ,
    ref: ref,
    rel: rel
  }, rest), buttonContent);
}
const ForwardedLinkButton = /*#__PURE__*/React.forwardRef(LinkButton);
export { ForwardedLinkButton as LinkButton };